module.exports = __webpack_public_path__ + "img/right.5dcfd157.svg";